var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesOptIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 32,
    fill: "#0072FF",
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.892 20.1c1.928 0 3.405-1.357 3.405-3.736 0-2.38-1.477-3.736-3.405-3.736-1.94 0-3.406 1.356-3.406 3.736 0 2.368 1.467 3.735 3.406 3.735zm0-1.36c-1.119 0-1.847-.835-1.847-2.376 0-1.542.728-2.376 1.847-2.376 1.115 0 1.846.834 1.846 2.376 0 1.54-.731 2.375-1.846 2.375zm5.818 3.305v-2.919h.046c.21.455.667.963 1.548.963 1.243 0 2.212-.984 2.212-2.81 0-1.874-1.012-2.805-2.208-2.805-.913 0-1.35.544-1.552.988h-.068v-.917h-1.491v7.5h1.513zm1.115-3.16c-.728 0-1.147-.64-1.147-1.612 0-.973.412-1.595 1.147-1.595.749 0 1.147.65 1.147 1.595 0 .951-.405 1.612-1.147 1.612zm5.668 1.19c.391-.015.668-.093.82-.142l-.237-1.126c-.075.014-.235.05-.377.05-.301 0-.51-.114-.51-.533v-2.642h1.025v-1.137h-1.026V13.24h-1.513v1.306h-.745v1.137h.745v2.84c-.007 1.07.721 1.599 1.818 1.553zm4.367-6.233c.451 0 .82-.344.82-.767 0-.419-.369-.763-.82-.763-.447 0-.817.344-.817.763 0 .423.37.767.817.767zM55.613 20v-5.455H54.1V20h1.513zm2.512 0v-3.153c.003-.704.422-1.115 1.033-1.115.608 0 .973.397.97 1.065V20h1.513v-3.473c0-1.271-.746-2.053-1.883-2.053-.81 0-1.395.398-1.64 1.034h-.064v-.963h-1.442V20h1.513z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 16,
    y: 100,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 8,
    x: 16,
    y: 88,
    fill: "#338EFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 16,
    y: 120,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 9c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2H12c-1.105 0-2-.895-2-2V11c0-1.105.895-2 2-2h16zm-16 3.356V21h16v-8.346l-6.728 5.888-.102.079c-.318.213-.733.225-1.063.03L20 18.58l-8-6.223zm-6.461.801l.101.075 3 2.5c.448.373.478 1.04.09 1.452l-.09.084-3 2.5c-.424.354-1.055.296-1.408-.128-.327-.391-.303-.959.036-1.322l.092-.086.877-.732H3c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L3 15.5h2.237l-.877-.732c-.392-.326-.47-.889-.203-1.307l.075-.101c.326-.392.889-.47 1.307-.203zM26.853 11h-13.34l7.063 5.493L26.853 11z",
    transform: "translate(48 36)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesOptIn);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-opt-in.177238e0.svg";
export { ForwardRef as ReactComponent };